var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 24.0001V20.9751H22V24.0001H2ZM4.05 18.3251V15.0001L13.375 5.67514L16.7 9.00014L7.375 18.3251H4.05ZM17.8 7.90014L14.475 4.57514L16.575 2.47514C16.7583 2.25847 16.9667 2.14597 17.2 2.13764C17.4333 2.1293 17.6667 2.2418 17.9 2.47514L19.85 4.42514C20.0667 4.6418 20.175 4.87097 20.175 5.11264C20.175 5.3543 20.0833 5.58347 19.9 5.80014L17.8 7.90014Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.7e81bf97cecfb9df4818dd7e9a881d67.svg";
export { ForwardRef as ReactComponent };